/* tslint:disable */
/* eslint-disable */
/**
 * BonusX - Auth Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AuthenticationBody } from '../models';
// @ts-ignore
import { AuthenticationResponse } from '../models';
// @ts-ignore
import { InlineObject } from '../models';
// @ts-ignore
import { InlineObject1 } from '../models';
// @ts-ignore
import { InlineResponse200 } from '../models';
// @ts-ignore
import { InlineResponse400 } from '../models';
// @ts-ignore
import { InlineResponse401 } from '../models';
// @ts-ignore
import { InputAuthenticationRegister } from '../models';
// @ts-ignore
import { InputChangePassword } from '../models';
// @ts-ignore
import { InputCheckExistingEmail } from '../models';
// @ts-ignore
import { InputSendForgotPasswordEmail } from '../models';
// @ts-ignore
import { Message4xx } from '../models';
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin: async (inlineObject?: InlineObject, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/adminLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationValidateGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (inputChangePassword?: InputChangePassword, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputChangePassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistingEmail: async (inputCheckExistingEmail?: InputCheckExistingEmail, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/check-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCheckExistingEmail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbilityRules: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/ability-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPassword: async (authenticationBody?: AuthenticationBody, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/login/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authenticationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicLogin: async (inlineObject1?: InlineObject1, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/magicLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (inputAuthenticationRegister?: InputAuthenticationRegister, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputAuthenticationRegister, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForgotPasswordEmail: async (inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/send-forgot-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputSendForgotPasswordEmail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/verify-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLogin(inlineObject?: InlineObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLogin(inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationValidateGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationValidateGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(inputChangePassword?: InputChangePassword, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(inputChangePassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkExistingEmail(inputCheckExistingEmail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAbilityRules(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAbilityRules(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithPassword(authenticationBody?: AuthenticationBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithPassword(authenticationBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async magicLogin(inlineObject1?: InlineObject1, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.magicLogin(inlineObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(inputAuthenticationRegister, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendForgotPasswordEmail(inputSendForgotPasswordEmail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAccount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAccount(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin(inlineObject?: InlineObject, options?: any): AxiosPromise<AuthenticationResponse> {
            return localVarFp.adminLogin(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationValidateGet(options?: any): AxiosPromise<void> {
            return localVarFp.authenticationValidateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(inputChangePassword?: InputChangePassword, options?: any): AxiosPromise<AuthenticationResponse> {
            return localVarFp.changePassword(inputChangePassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: any): AxiosPromise<boolean> {
            return localVarFp.checkExistingEmail(inputCheckExistingEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbilityRules(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getAbilityRules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPassword(authenticationBody?: AuthenticationBody, options?: any): AxiosPromise<AuthenticationResponse> {
            return localVarFp.loginWithPassword(authenticationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<object> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can login through SSI qrcode
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicLogin(inlineObject1?: InlineObject1, options?: any): AxiosPromise<AuthenticationResponse> {
            return localVarFp.magicLogin(inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: any): AxiosPromise<AuthenticationResponse> {
            return localVarFp.register(inputAuthenticationRegister, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.sendForgotPasswordEmail(inputSendForgotPasswordEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccount(options?: any): AxiosPromise<object> {
            return localVarFp.verifyAccount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - interface
 * @export
 * @interface AuthenticationApi
 */
export interface AuthenticationApiInterface {
    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {InlineObject} [inlineObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    adminLogin(inlineObject?: InlineObject, options?: any): AxiosPromise<AuthenticationResponse>;

    /**
     * Use this endpoint to check if the user is authenticated.
     * @summary Check user authentication status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationValidateGet(options?: any): AxiosPromise<void>;

    /**
     * 
     * @summary User can change password and login
     * @param {InputChangePassword} [inputChangePassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    changePassword(inputChangePassword?: InputChangePassword, options?: any): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: any): AxiosPromise<boolean>;

    /**
     * 
     * @summary User can load ability rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    getAbilityRules(options?: any): AxiosPromise<Array<object>>;

    /**
     * 
     * @summary User can login through email and password
     * @param {AuthenticationBody} [authenticationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    loginWithPassword(authenticationBody?: AuthenticationBody, options?: any): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @summary Logout from bonusx
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    logout(options?: any): AxiosPromise<object>;

    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {InlineObject1} [inlineObject1] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    magicLogin(inlineObject1?: InlineObject1, options?: any): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @summary Registration with email and password
     * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: any): AxiosPromise<AuthenticationResponse>;

    /**
     * 
     * @summary User can request an email to change their password
     * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: any): AxiosPromise<InlineResponse200>;

    /**
     * 
     * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    verifyAccount(options?: any): AxiosPromise<object>;

}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI implements AuthenticationApiInterface {
    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {InlineObject} [inlineObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public adminLogin(inlineObject?: InlineObject, options?: any) {
        return AuthenticationApiFp(this.configuration).adminLogin(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use this endpoint to check if the user is authenticated.
     * @summary Check user authentication status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationValidateGet(options?: any) {
        return AuthenticationApiFp(this.configuration).authenticationValidateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can change password and login
     * @param {InputChangePassword} [inputChangePassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public changePassword(inputChangePassword?: InputChangePassword, options?: any) {
        return AuthenticationApiFp(this.configuration).changePassword(inputChangePassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InputCheckExistingEmail} [inputCheckExistingEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public checkExistingEmail(inputCheckExistingEmail?: InputCheckExistingEmail, options?: any) {
        return AuthenticationApiFp(this.configuration).checkExistingEmail(inputCheckExistingEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can load ability rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getAbilityRules(options?: any) {
        return AuthenticationApiFp(this.configuration).getAbilityRules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can login through email and password
     * @param {AuthenticationBody} [authenticationBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithPassword(authenticationBody?: AuthenticationBody, options?: any) {
        return AuthenticationApiFp(this.configuration).loginWithPassword(authenticationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout from bonusx
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logout(options?: any) {
        return AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can login through SSI qrcode
     * @param {InlineObject1} [inlineObject1] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public magicLogin(inlineObject1?: InlineObject1, options?: any) {
        return AuthenticationApiFp(this.configuration).magicLogin(inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registration with email and password
     * @param {InputAuthenticationRegister} [inputAuthenticationRegister] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public register(inputAuthenticationRegister?: InputAuthenticationRegister, options?: any) {
        return AuthenticationApiFp(this.configuration).register(inputAuthenticationRegister, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can request an email to change their password
     * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public sendForgotPasswordEmail(inputSendForgotPasswordEmail?: InputSendForgotPasswordEmail, options?: any) {
        return AuthenticationApiFp(this.configuration).sendForgotPasswordEmail(inputSendForgotPasswordEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public verifyAccount(options?: any) {
        return AuthenticationApiFp(this.configuration).verifyAccount(options).then((request) => request(this.axios, this.basePath));
    }
}
